import http from "../httpService";
import {getBaseUrl} from "../../config";

const acceptStatuses = (...statuses) => status => statuses.includes(status);

export const getAgentProfile = () => http.get(
  `${getBaseUrl()}/agent-profile`,
  {validateStatus: acceptStatuses(200, 404)},
);

export const getAgentProfileChangeRequests = ({page = 1, limit = 10, status = ""} = {}) => {
  const params = new URLSearchParams({page: String(page), limit: String(limit)});
  if (status) {
    params.set("status", status);
  }
  return http.get(
    `${getBaseUrl()}/agent-profile/change-requests?${params.toString()}`,
  );
};

export const submitAgentProfileChanges = data => http.post(
  `${getBaseUrl()}/agent-profile/change-requests`,
  data,
  {validateStatus: acceptStatuses(201, 400, 409, 413, 415)},
);

export const uploadAgentProfileMedia = (field, file) => {
  const body = new FormData();
  body.append("file", file);

  return http.post(
    `${getBaseUrl()}/agent-profile/media/${field}`,
    body,
    {
      headers: {"Content-Type": "multipart/form-data"},
      validateStatus: acceptStatuses(201, 400, 409, 413, 415, 422),
    },
  );
};

export const withdrawAgentProfileChangeItem = itemId => http.post(
  `${getBaseUrl()}/agent-profile/change-items/${itemId}/withdraw`,
  {},
  {validateStatus: acceptStatuses(200, 400, 404, 409)},
);
